import React, { useContext, createContext, useState } from 'react'

import useEventListener from '@/utils/hooks/useEventListener'

const breakpoints = {
  mobile: [0, 576],
  tablet: [577, 992],
  bigTablet: [993, 1400],
  desktop: [1401, 1900],
  bigDesktop: [1900],
}

const getDisplayType = (currentWidth) => {
  if (currentWidth <= breakpoints.mobile[1]) {
    return 'mobile'
  }
  if (currentWidth <= breakpoints.tablet[1]) {
    return 'tablet'
  }
  if (currentWidth <= breakpoints.bigTablet[1]) {
    return 'bigTablet'
  }
  if (currentWidth <= breakpoints.desktop[1]) {
    return 'desktop'
  }
  return 'bigDesktop'
}

const getDisplayMoreThan = (width) => (display) => {
  return breakpoints?.[display]?.[0] ? width >= breakpoints?.[display][0] : true
}
const getDisplayLessThan = (width) => (display) => {
  return breakpoints?.[display]?.[1] ? width <= breakpoints?.[display][1] : true
}

export const DisplayContext = createContext()

export const useDisplay = () => useContext(DisplayContext)

export const DisplayProvider = (props) => {
  const currentDisplayType = getDisplayType(window.innerWidth)
  const [display, setDisplay] = useState(currentDisplayType)

  const handleResize = () => {
    const currentDisplayType = getDisplayType(window.innerWidth)
    setDisplay(currentDisplayType)
  }

  useEventListener({ eventName: 'resize', eventHandle: handleResize })
  const displayMoreThan = getDisplayMoreThan(window.innerWidth)
  const displayLessThan = getDisplayLessThan(window.innerWidth)

  const displayValues = {
    display,
    displayMoreThan,
    displayLessThan,
    isMobileView: displayLessThan('mobile'),
    isMdDesktop: displayMoreThan('tablet') && displayLessThan('bigTablet'),
    isDesktopView: displayMoreThan('bigTablet'),
    isBigDesktop: displayMoreThan('bigDesktop'),
  }

  return <DisplayContext.Provider value={displayValues} {...props} />
}
